import React from 'react';
import { observer } from 'mobx-react';
import stores from '../../../models/Stores';
import logoImg from '../../../assets/images/usda-logo--white.svg';
import './tophat.scss';

const TophatComponent = () => {
  const UserAvailable = stores.AppStore.userProfileStore.userAvailable;

  return (
    <header className="fsa-tophat fsa-tophat--fullscreen" role="banner">
      <div className="fsa-tophat__bd">
        <div className="fsa-tophat__primary">
          <span className="fsa-tophat__agency">
            <a className="fsa-tophat__link" href="//usda.gov" title="Link to USDA homepage">
              <img role="link" className="fsa-tophat__agency-logo" src={logoImg} alt="fpac logo" />
              <abbr className="fsa-tophat__agency-abbr" title="United States Department of Agriculture">
                USDA
              </abbr>
              <span className="fsa-tophat__agency-fullname">United States Department of Agriculture</span>
            </a>
          </span>
        </div>
        {UserAvailable ? <div className="fsa-tophat__secondary"></div> : null}
      </div>

      <a
        id="skip-to-main-content"
        aria-label="skip-to-main-content"
        className="skip-to-content-link usa-button usa-button--outline"
        href="#main"
        role="button"
      >
        Skip to main content
      </a>
    </header>
  );
};

export const Tophat = observer(TophatComponent);
